// The mod queue counts the notification bell shows (open bugs, ban appeals,
// flagged matches, mod reports) load after startup with their own bootstrap request, so the page never
// waits on the mod queries. A failure leaves the counts as they are.

export const MOD_COUNTS_SECTION = 'mod_counts';

export async function loadModCounts({ user, fetchSections, apply }) {
	if(!user.is_mod && !user.is_ladder_mod) {
		return;
	}
	try {
		const payload = await fetchSections([MOD_COUNTS_SECTION]);
		const sections = (payload && payload.sections) || {};
		if(!Object.prototype.hasOwnProperty.call(sections, MOD_COUNTS_SECTION)) {
			console.error('mod counts did not load', payload && payload.failed);
			return;
		}
		apply(sections[MOD_COUNTS_SECTION]);
	} catch(error) {
		console.error('mod counts request failed', error);
	}
}
